import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as S from './SrpActiveCard.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
import { Button } from '../../../../components/Button/Button';
import SeatSectionWrapper from '../SeatSectionWrapper/SeatSectionWrapper';
import { srpSelectedBusIdsSelector } from './../../../../containers/SRP/redux/selectors';
import { fetchBusDetails } from './../../../../containers/SeatLayout/redux/thunks';
import { setSrpCardIndex, updateSelectedBus } from './../../../../containers/SRP/redux/actions';
import { pushga, pushEcommerceGAEvent } from 'ga-utils';
import { SrpGAEvents } from './../../../../config/ga-config';
import { srpColorConfig } from './../../../../containers/Common/config'
import { fetchSeatLayoutData } from './../../../../containers/SeatLayout/redux/thunks'
import { updateSelectedBusData } from '../../../../containers/SeatLayout/redux/actions';
import { pushDataToNewrelic, getQueryString } from './../../../../containers/Common/Utils';
import FillingFast from '../FillingFast/FillingFast';
import PersuasionTag from '../PersuasionTag/PersuasionTag';
import NotificationLayout from '../NotificationLayout/NotificationLayout';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, calculateDroppingDate } from '../../../../utils/ctaHelper'
import { pushOmniEvents, CTA_TYPE } from '../../../../../shared/utils/PushEvents/Omniture/utils'
import { commonSelector, routeStateSelector } from '../../../../containers/Common/redux/selectors';
import { pushCtaOmniEvents } from '../../../../../shared/utils/PushEvents/Omniture/clickEvents'
import { IUserStoreState, userSelector } from 'user-reducer/src/user-reducer';
import { userLoyaltyInfo } from '../../../../containers/Home/redux/selectors';
import {logFeMetric, triggerSl} from '../../../../containers/SRP/redux/thunks'

let slMetricHeader = {
  headers:{
  'Content-Type': 'application/json'
},
  body:{
    pageName: "LISTING",
    type: "FeMetric",
    events: [
        {
            type: "FEATURE",
            name: "sponsored_listing",
     
        }
    ]
  }
}
const SrpActiveCard = props => {
  const dispatch = useDispatch();
  const { bus, openSeatLayout, index='' } = props;
  const selectedBusIds = useSelector(srpSelectedBusIdsSelector);
  const commonData = useSelector(commonSelector);
  const {doj,dojObj,src,dest} = commonData;
  const [selectedLinkName, setSelectedTab] = useState('');
  const userDetails = useSelector(userSelector) as IUserStoreState;
  const isLoggedIn = !!userDetails?.isLoggedIn;
  const {userInfo, loyaltyInfo={}} = userDetails;
  const routeStates = useSelector(routeStateSelector)
  const userLoyalty = useSelector(userLoyaltyInfo)
  const userTier = userLoyalty?.userLoyaltyInfo?.user_tier === undefined ? '' : `${userLoyalty?.userLoyaltyInfo?.user_tier}`
  const slRef = useRef<HTMLDivElement | null>(null)
  const [selectSeatsText, setSelectSeatsText] = useState('SELECT SEAT')
  const [slState, setSlState] = React.useState<any | null>({
    hasViewed: false,
    hasClicked: false
  })
  const viewAttributeUrl =
    bus?.adInventoryData?.attributionChannel.find((item: any) => item.type === 'VIEW')?.url ?? ''
  const clickAttributeUrl =
    bus?.adInventoryData?.attributionChannel.find((item: any) => item.type === 'CLICK')?.url ?? ''
  const is_sponsored = viewAttributeUrl !== '' ? true : false
  useEffect(() => {
    if (!selectedBusIds || !selectedBusIds.length) {
      setSelectedTab('');
    }
  }, [selectedBusIds])

  useEffect(() => {
    const link = getInitSelectedtab(selectedBusIds, bus)
    if (link && !selectedLinkName) {
      setSelectedTab(link);
      if (link == 'amenities_photos' || link == 'boarding_dropping') {
        //to support SEO
        dispatch(fetchBusDetails(bus))
        return;
      }
      if (!bus.chooseBpDpFirst) {
        dispatch(fetchSeatLayoutData({ busInfo: bus }));
      } else {
        dispatch(updateSelectedBusData({ bid: bus.bid, data: {}, isLoading: false, error: false }));
      }
    }
  }, [selectedBusIds])
  if (bus) {
    const {
      scheduleTxt,
      alertTxt,
      operatorName,
      busType,
      ratingCount,
      rating,
      departureTime,
      departurePoint,
      duration,
      restStops,
      arrivalDate,
      arrivaleTime,
      destinationPoint,
      isRedDeal,
      personalisedPrice,
      totalFare,
      reddeal,
      seatsAvailable,
      bid,
      ot,
      gps,
      fh,
      fd,
      aws,
      go_safe,
      soc_dis,
      soc_dis_msg,
      card_ps,
      socialDistance,
      socialDistanceIcon,
      ptag,
      adInventoryData
    } = bus;

    const { offerDesc } = reddeal;
  
    const trackSlViewed = () => {
      setSlState(async(prevSlState: any) => {
        if (!prevSlState?.hasViewed && bus?.adInventoryData && sessionStorage.getItem('VIEW') !== viewAttributeUrl) {
          triggerSl(bus?.adInventoryData, 'VIEW')
          slMetricHeader.body.events[0]['value'] = "view"
          const res = await logFeMetric(slMetricHeader)
          return {
            ...prevSlState,
            hasViewed: true
          }
        }
        return prevSlState
      })
    }

    useEffect(() => {
      const options = {
        threshold: 0.5 // Trigger when 50% of the div is visible
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            trackSlViewed()
          }
        })
      }, options)
      if (slRef.current) {
        observer.observe(slRef.current)
      }
      return () => {
        if (slRef.current) {
          observer.unobserve(slRef.current)
        }
      }
    }, [])

    const trackBusClick = async () => {
      if (!slState.hasClicked && bus?.adInventoryData && bus?.adInventoryData?.showAsAd  && sessionStorage.getItem('CLICK') !== clickAttributeUrl) {
        slMetricHeader.body.events[0]['value']= "click"
        const res = await logFeMetric(slMetricHeader)
        triggerSl(bus?.adInventoryData, 'CLICK')
        setSlState({
          ...slState,
          hasClicked: true
        })
      }
    }


    useEffect(()=>{
      if(selectedLinkName === 'seatLayout'){
        setSelectSeatsText('HIDE SEAT')
      }else{
        setSelectSeatsText('SELECT SEAT')
      }
    },[selectedLinkName])

    return (
      <S.ActivecardLayoutDiv ref={(bus?.adInventoryData && adInventoryData?.showAsAd === true) ? slRef : null}
      >
        <NotificationLayout bus={bus} />
        <S.ActivepcardInnerLayoutDiv>
          <S.AlerttextDiv>{alertTxt}</S.AlerttextDiv>
          <S.LayoutFirstDiv>
          <S.BusBoldtxtPara>
              {
                adInventoryData && adInventoryData?.showAsAd === true && adInventoryData?.iconUrl &&
                <S.AdImg src={adInventoryData?.iconUrl} height='20' width={'20'} />
              }{operatorName} </S.BusBoldtxtPara>
            <S.BusNormaltxtPara>{busType}</S.BusNormaltxtPara>
            {rating ? (
              <S.BusReviewOuterDiv>
                <S.BusReviewHighRatingSpan style={{ background: srpColorConfig[Math.round(rating)], borderColor: srpColorConfig[Math.round(rating)] }}>
                  <S.NumbersBoldSpan>{rating}</S.NumbersBoldSpan> /5
                </S.BusReviewHighRatingSpan>
                {ratingCount ? (
                  <>
                    <S.ReviewDividerSpan></S.ReviewDividerSpan>

                    <S.ReviewNumberSpan>{ratingCount} Ratings</S.ReviewNumberSpan>
                  </>
                ) : null}
              </S.BusReviewOuterDiv>
            ) : null}
          </S.LayoutFirstDiv>

          <S.LayoutSecondDiv>
            <S.DepartureWrapperDiv>
              <S.BusBoldtxtPara>{departureTime}</S.BusBoldtxtPara>

              <S.BusNormaltxtPara title={departurePoint}>{departurePoint}</S.BusNormaltxtPara>
            </S.DepartureWrapperDiv>
            <S.TotalDurationWrapperDiv>
              <S.DurationDiv>{duration}</S.DurationDiv>
              <S.JourneyDurationDiv>
                <S.StartSpan />
                <S.DistanceSpan />
                <S.StopSpan />
              </S.JourneyDurationDiv>
              <S.NumberofStopDiv>
                {restStops > 0 ? `${restStops} rest stop${restStops > 1 ? 's' : ''}` : ''}
              </S.NumberofStopDiv>
            </S.TotalDurationWrapperDiv>

            <S.ArrivalWrapperDiv>
              <S.ArrivalDatetxtPara>{arrivalDate}</S.ArrivalDatetxtPara>
              <S.BusBoldtxtPara>{arrivaleTime}</S.BusBoldtxtPara>
              <S.DropPointtxtPara title={destinationPoint}>{destinationPoint}</S.DropPointtxtPara>
            </S.ArrivalWrapperDiv>
          </S.LayoutSecondDiv>

          <S.LayoutThirdDiv>
            <S.BusPriceDetailsDiv>
              <S.BusPriceDiv>
                <S.PriceSeparationDiv>
                  <S.RupeeSpan>&#8377;</S.RupeeSpan>
                  <S.RupeetxtSpan>{isRedDeal ? personalisedPrice : totalFare}</S.RupeetxtSpan>
                </S.PriceSeparationDiv>
                {personalisedPrice !== totalFare ? (
                  <S.StrikedAmountPara>₹{totalFare}</S.StrikedAmountPara>
                ) : null}
                {(offerDesc && (
                  <S.OfferDetailsDiv>
                    <Icon
                      name="OffersIcon"
                      styleProps={{ fill: '#f4a900', width: '1.7rem', height: '1.7rem' }}
                    />
                    <S.OfferTxt>{offerDesc}</S.OfferTxt>
                  </S.OfferDetailsDiv>
                )) ||
                  ''}
              </S.BusPriceDiv>
              <S.BusDetailsDiv>
                <S.BusTimingWrapNewDiv>
                <FillingFast fast_persuasion={bus.fast_persuasion} />
                  {aws ? (
                    <S.TotalSeatsPara>
                      <span>{`${aws} window seat${aws > 1 ? 's' : ''}`}</span>
                      <Icon name="WindowSeatIcon" styleProps={{}}></Icon>
                    </S.TotalSeatsPara>
                  ) : null}
                  <S.BusNormaltxtPara seatsAvailable={seatsAvailable}>
                    {`Total ${seatsAvailable} seat${seatsAvailable > 1 ? 's' : ''} left`}
                  </S.BusNormaltxtPara>
                  <S.BusBtnDiv>
                    <Button minWidth={"128px"}
                      onClick={() => {
                        // pushCtaOmniEvents(selectedLinkName?'Hide Seats':'Show Seats', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');
                        dispatch(setSrpCardIndex(index))
                        pushDataToNewrelic(`seatLayoutCall=${bus.bid}`);
                   
                        if(selectedBusIds.indexOf(bid) === -1 || selectSeatsText === 'HIDE SEAT'){
                          console.log({selectedLinkName})
                          openSeatLayout(bus);
                          setSelectedTab('')
                          setSelectSeatsText('SELECT SEAT')
                        }else{
                          setSelectedTab('seatLayout');
                        }
                        trackBusClick()
                        pushga({
                          event: SrpGAEvents.actions.bus_proceedtoSeat.val,
                          eventCategory: SrpGAEvents.category,
                          eventAction: SrpGAEvents.actions.bus_proceedtoSeat.val,
                          eventLabel: selectedLinkName
                            ? SrpGAEvents.actions.bus_proceedtoSeat.labels['hide']
                            : SrpGAEvents.actions.bus_proceedtoSeat.labels['show'],
                        });

                        pushEcommerceGAEvent({
                          pageViewEvents: {
                            cdBusSearchDestination: `${bus.origin}`,
                            cdBusSearchOrigin: `${bus.destination}`,
                            cdBusSearchReturnDate: "",
                            cdCatQuery: "bus-domestic",
                            cdSubCatQuery: "OneWay",
                            cdVisitorSegment: "",
                            userid: "",
                          },
                          event: "virtualPageView",
                          virtualPage: "srp?page=busSeatSelection",
                        });
                        
                        const eventDetails = {
                          page: {
                            pageInfo: {
                              section: "domestic bus funnel",
                              pageName: "funnel:domestic bus:listing",
                              pageType: "funnel",
                              lob: "domestic bus",
                              siteName: 'GI',
                              platform: 'dweb',
                              flow: "direct-bus",
                              loadedComponents: 'BP/DP|SeatLayout',
                              abVariant: '',
                              deviceId: "",
                              loyaltyStatus_v44:`Tier${loyaltyInfo?.status !=='INACTIVE' ? loyaltyInfo?.currentTier?.tierNumber || '' : '0'}_${loyaltyInfo?.status || ''}`                            
                            },
                          },
                          account: {
                            accountInfo: {
                              custID: userInfo?.userid? `${userInfo?.userid}` :'',
                              loginStatus:  isLoggedIn? "Logged-In" : "Guest",
                              goCash: userDetails?userDetails.gocashInfo ? `${userDetails?.gocashInfo?.data?.t_amt}` : "":'',
                              loyaltyStatus: userTier,
                              "hydraSegment": "",
                            },
                          },
                          cta: ctaHelper(['Select_Seat', CTA_TYPE.BUTTON, 'Select_Seat_SRP', 'Seat_Layout']),
                          productListItems: [{
                              SKU: bid,
                              productInfo: {
                                  productName: `${operatorName}`,
                                  productPosition: `${index}`,
                                  busNitroDealsBanner: bus.is_nitro ? 'Y' : 'N',
                                  "busLoginDealsBanner": bus.reddeal ? bus.reddeal?.persuasion ?'Y':'N' : 'N',
                              }
                          }],
                          booking: {
                              routeCity: `${src}-${dest}`,
                              routeState : (routeStates.srcState && routeStates.destState) ?  `${routeStates.srcState}-${routeStates.destState}` : '',
                              daysToTrip: `${calculateDaysToTrip(dojObj)}`,
                              departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(doj)}`,
                              droppingDate:`${calculateDroppingDate(convert_yyyymmdd_to_dd_mm_dddd(doj), departureTime, arrivaleTime)}`,
                              departureTime: `${departureTime}`,
                              droppingTime: `${arrivaleTime}`,
                              duration: `${duration}`,
                              AvailabeSeats: `${seatsAvailable}`,
                              AvailabeWindowSeats: `${aws}`,
                              Ratings: rating?`${rating}`:'',
                              baseFare: `${fd?.tf}`
                          },
                        };
                        selectedLinkName == '' && pushOmniEvents({ eventName: 'busResultClick', details: eventDetails }) 
                      }}
                    >
                      <S.PayBtnWrapDiv>
                        <S.PayTxtSpan>
                          {selectSeatsText}
                        </S.PayTxtSpan>
                      </S.PayBtnWrapDiv>
                    </Button>
                  </S.BusBtnDiv>
                </S.BusTimingWrapNewDiv>
              </S.BusDetailsDiv>
            </S.BusPriceDetailsDiv>
          </S.LayoutThirdDiv>
          <PersuasionTag ptag={ptag} />
        </S.ActivepcardInnerLayoutDiv>

        {soc_dis && false ?
          <S.InfoBlock>
            <S.goSafeTag>
              <Icon name="SocialDistanceIcon" />
              <span>Social Distancing</span>
            </S.goSafeTag>
            <S.SCText>{soc_dis_msg || ''}</S.SCText>
          </S.InfoBlock> : null}
        {card_ps && Object.keys(card_ps).length && card_ps.t ?
          <S.InfoBlock>
            {false ? <Icon name='DoubleTickIcon' /> : null}
            <img src={card_ps.l} alt="" style={{ height: "15px", width: "18px" }}></img>
            <S.GoSafePersuationTxt>{card_ps.t}</S.GoSafePersuationTxt>
          </S.InfoBlock> : null}
        {/* card footer links */}
        <S.AmminitiesLayoutDiv>
          <S.AmminitiesInnerLayoutDiv>
            {go_safe ? (
              <S.InnerContentLayoutDiv>
                <img src="https://gos3.ibcdn.com/goSafelogo-1591083260.png" width="48px" alt="" />
              </S.InnerContentLayoutDiv>
            ) : null}

            {socialDistance && false ? <S.InnerContentLayoutDiv>
              <S.SocialDistanceActive>
                <Icon name="SocialDistanceIcon" styleProps={{ fill: '#148730' }} />
                <S.TextSpan style={{ color: '#148730', fontWeight: 'bold' }}>Social Distancing</S.TextSpan>
              </S.SocialDistanceActive>
              <S.SDTooltip>This bus follows Social distancing by blocking nearby seats. </S.SDTooltip>
            </S.InnerContentLayoutDiv>
              : null}
            {
              socialDistanceIcon && Object.keys(socialDistanceIcon).length
                ? (
                  <S.InnerContentLayoutDiv>
                    <Icon name={socialDistanceIcon.icon} styleProps={{ fill: socialDistanceIcon.c }} />
                    <S.TextSpan style={{ color: socialDistanceIcon.c, fontWeight: 'bold' }}>{socialDistanceIcon.title}</S.TextSpan>
                  </S.InnerContentLayoutDiv>
                ) : null}
            {ot ? (
              <S.InnerContentLayoutDiv>
                <Icon name="Timer" styleProps={{ fill: '#647a97' }} />
                <S.TextSpan>On- time guarantee</S.TextSpan>
              </S.InnerContentLayoutDiv>
            ) : null}
            {gps ? (
              <S.InnerContentLayoutDiv>
                <Icon
                  name="LiveBus"
                  styleProps={{ fill: '#647a97', width: '1.8rem', height: '1.8rem' }}
                />
                <S.TextSpan>Live Tracking</S.TextSpan>
              </S.InnerContentLayoutDiv>
            ) : null}
          </S.AmminitiesInnerLayoutDiv>
          {!selectedLinkName ? (
            <S.AmminitiesInnerLayoutDiv>
              <S.BoadingElink
                onClick={() => {
                  setSelectedTab('boarding_dropping');
                  dispatch(updateSelectedBus(bid));

                  dispatch(fetchBusDetails(bus));
                  pushga({
                    event: SrpGAEvents.actions.bus_boardingdropping,
                    eventCategory: SrpGAEvents.category,
                    eventAction: SrpGAEvents.actions.bus_boardingdropping,
                  });
                  pushCtaOmniEvents('BP_DP', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    
                }}
              >
                Boarding & Dropping Points
              </S.BoadingElink>
              <S.BoadingElink
                onClick={() => {
                  setSelectedTab('amenities_photos');
                  dispatch(updateSelectedBus(bid));

                  dispatch(fetchBusDetails(bus));
                  pushga({
                    event: SrpGAEvents.actions.bus_moredetails,
                    eventCategory: SrpGAEvents.category,
                    eventAction: SrpGAEvents.actions.bus_moredetails,
                  });
                  pushCtaOmniEvents('Amenities_Photos', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    
                }}
              >
                Amenities, Policies & Bus Details
              </S.BoadingElink>
              <S.IconWrap onClick={() => {
                setSelectedTab('amenities_photos');
                dispatch(updateSelectedBus(bid));

                dispatch(fetchBusDetails(bus));
                pushga({
                  event: SrpGAEvents.actions.bus_moredetails,
                  eventCategory: SrpGAEvents.category,
                  eventAction: SrpGAEvents.actions.bus_moredetails,
                });
              }}>
                <Icon
                  name='DropArrowIcon'
                  styleProps={{ width: '0.9rem', height: '0.9rem', fill: '#2276e3' }}
                />{' '}
              </S.IconWrap>
            </S.AmminitiesInnerLayoutDiv>
          ) : (
            <S.AmminitiesInnerLayoutDiv>
              <S.BoadingElink
                onClick={() => {
                  setSelectedTab('');
                  dispatch(updateSelectedBus(bid));

                  pushga({
                    event: SrpGAEvents.actions.bus_hide_details,
                    eventCategory: SrpGAEvents.category,
                    eventAction: SrpGAEvents.actions.bus_hide_details,
                  });
                }}
              >
                Hide Details
              </S.BoadingElink>
              <S.IconWrap onClick={() => {
                setSelectedTab('');
                dispatch(updateSelectedBus(bid));

                pushga({
                  event: SrpGAEvents.actions.bus_hide_details,
                  eventCategory: SrpGAEvents.category,
                  eventAction: SrpGAEvents.actions.bus_hide_details,
                });
              }}>
                <Icon
                  name="DropArrowIcon"
                  styleProps={{ width: '0.9rem', height: '0.9rem', fill: '#2276e3', transform: "rotate(180deg)" }}
                />{' '}
              </S.IconWrap>
            </S.AmminitiesInnerLayoutDiv>
          )}
        </S.AmminitiesLayoutDiv>
        {selectedBusIds && selectedBusIds.length && selectedBusIds.indexOf(bid) !== -1 ? <SeatSectionWrapper
          bid={bid}
          busData={bus}
          selectedBusIds={selectedBusIds}
          selectedLinkName={selectedLinkName}
          routeId={fh}
          setSelectedSeatCopy={props.setSelectedSeatCopy}
          selectedSeatCopy={props.selectedSeatCopy}
          is_sponsored={is_sponsored}
          is_bo_ads={props.is_bo_ads}
          isRTC={props?.isRTC}
          setSelectedTab={setSelectedTab}
        ></SeatSectionWrapper> : null}
      </S.ActivecardLayoutDiv>
    );
  } else {
    return null;
  }
};

export default SrpActiveCard;

const getInitSelectedtab = (selectedBusIds, bus) => {
  if (selectedBusIds && selectedBusIds.length && selectedBusIds.indexOf(bus.bid) !== -1) {
    if (typeof window != "undefined") {
      //to support SEO

      const searchString = window.location.search;
      const section = getQueryString('section', searchString);

      if (section !== null && section && section.length) {
        return section
      }
    }

    return 'seatLayout';
  }
  return ''
}